import React from 'react';
import PropTypes from 'prop-types';
import { UploadIcon } from 'DesignSystem/Icons';

class UploadButton extends React.PureComponent {
  componentDidMount() {
    window.Upload.cdn_url = window.cdnUrl;
    window.Upload.activateUploadButtonById(
      this.props.id,
      this.props.uploadType,
      this.props.uploadEndpoint,
    );
  }

  render() {
    // window.Upload only works correctly on IE with <a /> tags.
    // For this reason, we cannot use our PrimaryButton component.
    return (
      <div style={{ display: 'flex' }}>
        <a
          className="ds-btn-primary md"
          id={this.props.id}
          onClick={this.props.onClick}
          style={this.props.style}
        >
          {this.props.showIcon &&
            <UploadIcon />
          }
          {this.props.text}
        </a>
      </div>
    );
  }
}

UploadButton.defaultProps = {
  onClick: () => null,
  showIcon: true,
  style: {},
  uploadType: 'custom-template',
  uploadEndpoint: `${window.API_URL}/custom-template`,
};

UploadButton.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  showIcon: PropTypes.bool,
  style: PropTypes.shape({}),
  text: PropTypes.string.isRequired,
  uploadEndpoint: PropTypes.string,
  uploadType: PropTypes.string,
};

export default UploadButton;



// WEBPACK FOOTER //
// ./src-react/UploadButton/index.jsx